//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LANGUAGE_FLAG_IMGS } from '~/utils/runtimeConstants'

const iterateOptions = (options, callback) => {
  options.forEach((option) => {
    if (option.type === 'group') {
      iterateOptions(option.options, callback)
      return
    }

    callback(option)
  })
}

export default {
  props: {
    feature: {
      type: Object,
      required: true,
    },
    priceList: {
      type: Object,
      required: true,
    },
    periodUnit: {
      type: String,
      required: true,
    }
  },
  computed: {
    featureOptions () {
      const config = this.priceList.data.feature_configs?.find(config => config.feature_id === this.feature.id)
      if (!config) {
        return null
      }

      iterateOptions(config.options, (option) => {
        if (option.quantity === null) {
          option.text = this.feature.value
          return
        }

        const addon = this.priceList.addons.find(addon => addon.addon_id === option.addon_id)
        const price = addon?.prices.find(price => price.period_unit === this.periodUnit)
        if (!addon || !price) {
          return
        }

        option.text = this.$t('priceListFeatureRow.signature-label', {
          quantity: option.quantity,
          unitPrice: this.$n(price.monthly_price * 12 / option.quantity / 100, 'currencyLong'),
          monthlyPrice: this.$n(price.monthly_price / 100, 'currencyLong')
        })
      })

      return config.options
    }
  },
  methods: {
    flag (language) {
      return LANGUAGE_FLAG_IMGS[language]
    }
  }
}
